import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUtensils } from '@fortawesome/free-solid-svg-icons';
import dayjs from 'dayjs';

import './OrderCompleted.less';

const OrderCompleted = ({ orderData }) => {
	const { start_time, end_time, price, meal_name, drink_name, display_id, order_customizations } = orderData;
	const drinkCustomizations = order_customizations ? order_customizations.filter(item => item.customization_type === 'drink') : null;
	const mealCustomizations = order_customizations ? order_customizations.filter(item => item.customization_type === 'meal') : null;

	const total = price + order_customizations.reduce((sum, item) => sum + item.option_price || 0, 0);

	return (
		<div className="order-completed">
			<div className="order-completed-header">
				<div className="order-completed-icon-wrapper">
					<FontAwesomeIcon
						icon={faUtensils}
						className="order-completed-icon"
					/>
				</div>
				<h2 className="order-completed-title">祝您用餐愉快！Enjoy your meal!</h2>
				<p className="order-completed-subtitle">感謝您選擇與我們用餐。Thank you for dining with us.</p>
			</div>

			<div className="order-details-section">
				<div className="order-status-badge completed">
					<span>已取餐 Completed</span>
				</div>

				<div className="order-detail-row">
					<span className="detail-label">訂單編號 Order ID</span>
					<span className="detail-value">{display_id}</span>
				</div>

				<div className="order-detail-row">
					<span className="detail-label">取餐時段 Pickup Timeslot</span>
					<span className="detail-value">{start_time && end_time ? `${dayjs(start_time).format('HH:mm')} - ${dayjs(end_time).format('HH:mm')}` : 'N/A'}</span>
				</div>

				<div className="order-detail-row">
					<span className="detail-label">訂單摘要 Order Summary</span>
					<div className="detail-value">
						<div>• {meal_name}</div>
						{mealCustomizations &&
							<ul style={{ listStyle: 'circle' }}>
								{mealCustomizations.map(option => (
									<li>{option.option_name}</li>
								))}
							</ul>
						}
						{drink_name && <div>• {drink_name}</div>}
						{drinkCustomizations &&
							<ul style={{ listStyle: 'circle' }}>
								{drinkCustomizations.map(option => (
									<li>{option.option_name}</li>
								))}
							</ul>
						}
					</div>
				</div>

				<div className="order-detail-row">
					<span className="detail-label">總額 Total</span>
					<span className="detail-value">${total.toFixed(2)}</span>
				</div>
			</div>
		</div>
	);
};

export default OrderCompleted;
